<template>
  <my-view :GetShopOrderDetail="GetShopOrderDetail"></my-view>
</template>

<script>
import { GetShopOrderDetail } from "@/pages/page1/api/modules/order";

import MyView from "@/pages/publicView/personalCenter/myOrder/printOrder_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      GetShopOrderDetail,
    };
  },
};
</script>